import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import ItemThumbnailsList from 'yoda-checkout-components/lib/components/ItemThumbnailsList/ItemThumbnailsList';
import { SRV_BOPIS_STORE_DISTANT_FROM_ZIP } from 'yoda-checkout-components/lib/common/Constants';
import { isDistantBillingAddress } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import PickupStoreDetails from 'yoda-checkout-components/lib/components/PickupStoreDetails/PickupStoreDetails';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import BopisHolidayMessage from 'yoda-checkout-components/lib/components/BopisHolidayMessage/BopisHolidayMessage';
import BopisExclusionWarning from 'yoda-checkout-components/lib/components/BopisExclusionWarning/BopisExclusionWarning';
import PickupPersonInfo from '../../../../../components/PickupPersonInfo/PickupPersonInfo';
import ShowItemDetailsLink from '../../../../../components/ShowItemDetailsLink/ShowItemDetailsLink';
import DistantStoreMessage from '../../../../../components/DistantStoreMessage/DistantStoreMessage';
import checkoutStaticText from '../../../../../helpers/LabelConstantsCheckout';
import { getProductPPIds } from '../../../../../helpers/Utils/Utils';

export function SameDayPickupReviewSection(props) {
    const {
        bopisItems,
        selectedStore,
        alternatePickupInfo,
        warnings,
        isCurbSideAvailable,
        curbSideText,
        pickupDateMessage,
        isNative,
    } = props;
    const isShowDistantMessage = isDistantBillingAddress(
        warnings,
        SRV_BOPIS_STORE_DISTANT_FROM_ZIP
    );

    return (
        <div className={dt(['lg:m-2', 'md:m-0'])}>
            <div
                className={dt([
                    'bg-white',
                    'sm:pt-6',
                    'sm:px-0',
                    'lg:p-6',
                    'smMd:pt-6',
                    'smMd:px-0',
                ])}
                data-automation-id="at-review-samedaypickup-section-container"
                data-ppId={getProductPPIds(bopisItems)}
            >
                <BopisHolidayMessage source="review" />
                {isShowDistantMessage && (
                    <DistantStoreMessage selectedStore={selectedStore} isSDPUSection />
                )}
                <BopisExclusionWarning fromPage="checkout" />
                <div>
                    <ItemThumbnailsList
                        items={bopisItems}
                        automationId="at-review-sdpu-thumb-list"
                        isPromseDateDelivery
                    />
                    <div className={dt(['mt-6'])}>
                        <ShowItemDetailsLink isNative={isNative} />
                    </div>
                </div>
                <PickupStoreDetails selectedStore={selectedStore} />
                <div>
                    <PickupPersonInfo pickupPersonInfo={alternatePickupInfo} />
                    <div className={dt(['text-medium', 'mt-6', 'font-open-sans-semibold'])}>
                        <span>Pickup Items: {pickupDateMessage}</span>
                    </div>
                    <div className={dt(['text-black'])}>
                        <span className={dt(['text-small'])}>
                            {checkoutStaticText.EMAIL_NOTIFICATION_MESSAGE}
                        </span>
                    </div>
                    {isCurbSideAvailable && (
                        <div>
                            <div className={dt(['font-open-sans-semibold', 'text-medium', 'mt-6'])}>
                                {curbSideText.curbSidePickup}
                            </div>
                            <div className={dt(['font-open-sans-regular', 'text-small'])}>
                                {curbSideText.curbSideSDPUMessage}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

SameDayPickupReviewSection.propTypes = {
    bopisItems: PropTypes.oneOfType([PropTypes.array]).isRequired,
    selectedStore: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    alternatePickupInfo: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    ),
    isCurbSideAvailable: PropTypes.bool,
    curbSideText: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
    warnings: PropTypes.arrayOf(PropTypes.object),
    isNative: PropTypes.bool,
    pickupDateMessage: PropTypes.string,
};

SameDayPickupReviewSection.defaultProps = {
    selectedStore: {},
    alternatePickupInfo: {},
    curbSideText: {},
    isCurbSideAvailable: false,
    warnings: [],
    isNative: false,
    pickupDateMessage: '',
};

const mapStateToProps = ({ context, orderInfo }) => ({
    warnings: get(orderInfo, 'status.warnings', []),
    isNative: get(context, 'isNative', false),
});

export default connect(mapStateToProps)(SameDayPickupReviewSection);
